export enum FormFactorConstants {
  TABLET = 'tablet',
  MOBILE = 'mobile',
}
